// extracted by mini-css-extract-plugin
export default {"heading":"_6wQf8","text":"_2Ufxe"};